/**
 * Plain-language descriptions for synthetic-PK formulas declared by
 * the interpretation phase (``SyntheticPkFormula.strategy``).
 *
 * Phase 3 retired the standalone value-catalog construct; the PK
 * helper lived in ``lib/valueCatalogs`` historically only because the
 * two artifacts both landed on the schema viewer at the same time.
 * It is unrelated to catalog mechanics and lives standalone now.
 */

/**
 * Translate a synthetic-PK formula `strategy` into a plain-language
 * phrase suitable to drop into "ID is built by …".
 */
export function describePkStrategy(
  strategy?: string | null,
  inputs?: string[] | null,
): string {
  switch ((strategy || '').toLowerCase()) {
    case 'hash_identity':
      if (inputs && inputs.length > 0) {
        return `hashing ${inputs.join(' + ')} together`;
      }
      return 'hashing identity inputs together';
    case 'uuid':
      return 'generating a unique identifier';
    case 'row_number':
      return 'counting rows';
    default:
      return strategy ? strategy : '';
  }
}
